export const ELEMENT_PROPERTIES = {
  input: [
    { key: "value", label: "value", type: "text" },
    { key: "is_valid", label: "is valid", type: "boolean" },
    { key: "is_empty", label: "is empty", type: "boolean" },
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
  ],
  button: [
    { key: "is_clickable", label: "is clickable", type: "boolean" },
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
  ],
  text: [
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
    { key: "is_visible", label: "is visible", type: "boolean" },
  ],
  column_container: [
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
    { key: "is_visible", label: "is visible", type: "boolean" },
  ],
  link: [
    { key: "is_clickable", label: "is clickable", type: "boolean" },
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
  ],
  navbar: [
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
    { key: "is_visible", label: "is visible", type: "boolean" },
  ],
  banner: [
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
    { key: "is_visible", label: "is visible", type: "boolean" },
  ],
  header: [
    { key: "width", label: "width", type: "number" },
    { key: "height", label: "height", type: "number" },
    { key: "is_visible", label: "is visible", type: "boolean" },
  ],
};


export const EXPRESSION_SOURCES = [
  { key: "current_user", label: "Current User"},
  { key: "search", label: "Do a Search"},
  { key: "custom", label: "Custom Text"},
];
